import { useState } from 'react';

interface EditState<T> {
  toBeEdited: T | undefined;
  setToBeEdited: (arg0: T | undefined) => void;
  editIndex: number | undefined;
  setEditIndex: (arg0: number | undefined) => void;
}

const useEditState = <T>(defaultIndex?: number): EditState<T> => {
  const [toBeEdited, setToBeEdited] = useState<T>();
  const [editIndex, setEditIndex] = useState<number | undefined>(defaultIndex);

  return {
    toBeEdited,
    setToBeEdited,
    editIndex,
    setEditIndex,
  };
};

export default useEditState;
